import { render } from "./StroageFiles.vue?vue&type=template&id=13a3c666"
import script from "./StroageFiles.vue?vue&type=script&lang=js"
export * from "./StroageFiles.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__